<!-- An installed app that lands here has lost its way back to a campaign — see LandingPageComponent. -->
@if (isStandaloneLaunch) {
<section class="standalone-launch flex flex-column gap-8 items-center justify-center text-center">
  <div class="icon-container-filled primary flex justify-center items-center">
    <span class="material-symbols-outlined">{{ hasCampaignToReturnTo ? 'campaign' : 'qr_code_scanner' }}</span>
  </div>

  @if (hasCampaignToReturnTo) {
  <div class="flex flex-column gap-3">
    <div class="mat-title-large font-weight-bold">Pick up where you left off</div>
    <div class="mat-body-medium font-weight-light">Your last campaign is still open — carry on from the step you
      stopped at.</div>
  </div>
  <button matButton="filled" class="standalone-launch-action" (click)="returnToCampaign()">
    <mat-icon>arrow_right_alt</mat-icon>
    Return to your campaign
  </button>
  } @else {
  <div class="flex flex-column gap-3">
    <div class="mat-title-large font-weight-bold">Scan your campaign QR code</div>
    <div class="mat-body-medium font-weight-light">AAuto is installed and ready. Scan the QR code on the campaign you
      want to follow and it will open right here.</div>
  </div>
  }

  <button matButton (click)="showLandingPage()">About AAuto</button>
</section>
} @else {
<div class="flex flex-column">
  <mat-toolbar>
    <div class="flex flex-row justify-between flex-fill items-center">
      <div class="flex flex-row items-center gap-2">
        <svg class="aauto-logo" width="100%" height="100%" viewBox="0 0 56 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M25.0605 0.790596C26.8793 -0.264184 29.1207 -0.264183 30.9395 0.790596L53.0605 13.6207C54.8792 14.6754 55.9998 16.6245 56 18.734V44.3931C56 46.5028 54.8793 48.4526 53.0605 49.5074L30.9395 62.3365C29.1206 63.3913 26.8794 63.3913 25.0605 62.3365L2.93945 49.5074C1.12065 48.4526 0 46.5028 0 44.3931V18.734C0.00015479 16.6245 1.12077 14.6754 2.93945 13.6207L25.0605 0.790596ZM30.9443 3.84431C29.1221 2.79135 26.8769 2.79124 25.0547 3.84431L5.49023 15.1509L5.32129 15.2525C3.59896 16.326 2.54607 18.2162 2.5459 20.2564V42.8707L2.54883 43.0679C2.6165 45.0978 3.72508 46.956 5.49023 47.9761L25.0547 59.2828C26.8769 60.3359 29.1221 60.3358 30.9443 59.2828L50.5098 47.9761C52.2748 46.9559 53.3835 45.0977 53.4512 43.0679L53.4541 42.8707V20.2564C53.4539 18.1504 52.3318 16.204 50.5098 15.1509L30.9443 3.84431ZM25.791 5.12067C27.1576 4.33091 28.8414 4.33106 30.208 5.12067L49.7734 16.4273C51.1399 17.2171 51.9823 18.677 51.9824 20.2564V42.8707C51.9824 44.4502 51.14 45.9099 49.7734 46.6998L30.208 58.0064C28.8413 58.7961 27.1576 58.7962 25.791 58.0064L6.22656 46.6998C4.8599 45.9099 4.01761 44.4503 4.01758 42.8707V20.2564C4.01775 18.6769 4.86002 17.2171 6.22656 16.4273L25.791 5.12067ZM31.4746 13.7457C30.9746 13.7457 30.5287 14.0644 30.3633 14.5406L28.2764 20.5465L26.2266 14.5982C26.0619 14.1208 25.6152 13.8013 25.1143 13.8013H21.6562C21.1563 13.8014 20.7113 14.1201 20.5459 14.5963L10.249 44.2379C9.98106 45.0102 10.5494 45.8179 11.3604 45.8179H14.2529C14.7533 45.8179 15.1991 45.4987 15.3643 45.022L18.0723 37.2056H21.1719C21.2334 37.2056 21.2832 37.1554 21.2832 37.0933C21.2831 35.6403 20.4636 34.3813 19.2656 33.7593L22.291 25.0289C22.6594 23.9661 24.1498 23.9687 24.5146 25.0328L25.6094 28.2261L20.0674 44.1822C19.7993 44.9545 20.3668 45.7622 21.1777 45.7623H24.0713C24.5715 45.7621 25.0166 45.4429 25.1816 44.9664L28.2812 36.0191L31.3672 45.0191C31.5313 45.4975 31.9788 45.8179 32.4805 45.8179H35.3311C36.141 45.8179 36.7094 45.0118 36.4434 44.2398L33.792 36.5504C34.768 35.875 35.4092 34.7421 35.4092 33.4576C35.409 33.3957 35.3592 33.3454 35.2979 33.3453H32.6875L30.9521 28.3101L32.1094 24.9732C32.4778 23.9106 33.9682 23.9131 34.333 24.9771L41.1855 44.9634C41.3497 45.4418 41.7962 45.7623 42.2979 45.7623H45.1494C45.9592 45.7621 46.5268 44.956 46.2607 44.1842L36.0439 14.5425C35.8792 14.0653 35.4335 13.7457 34.9326 13.7457H31.4746Z" fill="var(--mat-sys-on-surface)"/>
        </svg>
        <div class="mat-title-medium font-weight-bold">Aauto</div>
      </div>
      <div class="flex flex-row gap-4">
        <button matButton >
          Contact us
        </button>
        <button matButton="outlined" (click)="login()">
          <mat-icon>login</mat-icon>
          Login
        </button>
      </div>
    </div>
  </mat-toolbar>

  <!-- Hero banner -->
  <section class="flex flex-column hero-container-fluid inverse-surface justify-center items-center">
    <div class="flex gap-10 flex-row container-1024 justify-center items-center">
      <div class="flex flex-column gap-6">
        <div class="flex flex-row gap-4">
          <div class="custom-badge flex flex-row items-center gap-2">
            <span class="pulse-dot-primary"></span>
            <span class="mat-body-small">Advertising Management Platform</span>
          </div>
        </div>
        <div class="mat-display-large font-weight-bold">
            Run campaigns<br/>
            that <span class="accent-primary">convert</span>.<br/>
            Track every<br/>
            <span class="accent-primary">scan</span>.
        </div> 
        <div class="flex flex-row mat-body-large font-weight-light">
            Create campaigns, generate trackable QR codes, and monitor real-time performance — all in one clean dashboard. From first print to final conversion.
        </div>
        <div class="flex flex-row gap-4 items-center">
          <div class="flex flex-row gap-1">
                <div class="avatar flex items-center justify-center primary-container mat-body-small font-weight-regular">SA</div>
                <div class="avatar flex items-center justify-center secondary-container mat-body-small font-weight-regular">MK</div>
                <div class="avatar flex items-center justify-center tertiary-container mat-body-small font-weight-regular">RJ</div>
          </div>
          <div class="flex flex-column">
            <div class="flex flex-row gap-1">
              <span class="mat-body-small primary-container">★</span>
              <span class="mat-body-small primary-container">★</span>
              <span class="mat-body-small primary-container">★</span>
              <span class="mat-body-small primary-container">★</span>
              <span class="mat-body-small primary-container">★</span>
            </div>
            <div class="flex mat-body-small font-weight-light secondary-color">Trusted by 100+ marketing teams</div>
          </div>
        </div>
      </div>

      <!-- Dashboard Mock -->
      <div class="dashboard-mockup flex flex-column hide-1024 basis-50">
                
        <!-- Browser Bar -->
        <div class="browser-bar">
            <div class="browser-buttons">
                <div class="browser-button"></div>
                <div class="browser-button"></div>
                <div class="browser-button"></div>
            </div>
            <div class="browser-url-bar">
                <div class="url-indicator-dot"></div>
                <span class="url-text">app.aauto.io/dashboard</span>
            </div>
            <div class="browser-controls">
                <div class="browser-control-btn"></div>
                <div class="browser-control-btn"></div>
                <div class="browser-control-btn"></div>
            </div>
        </div>
    
        <!-- App Shell -->
        <div class="app-shell flex flex-row">
            
            <!-- Sidebar -->
            <div class="sidebar flex flex-column p-box-8">
                <div class="sidebar-logo">
                    <div class="sidebar-logo-inner"></div>
                </div>
                <!-- Active icon -->
                <div class="sidebar-icon active">
                    <div class="sidebar-icon-inner"></div>
                </div>
                <!-- Inactive icons -->
                <div class="sidebar-icon">
                    <div class="sidebar-icon-inner"></div>
                </div>
                <div class="sidebar-icon">
                    <div class="sidebar-icon-inner"></div>
                </div>
                <div class="sidebar-icon">
                    <div class="sidebar-icon-inner"></div>
                </div>
                <div class="sidebar-icon">
                    <div class="sidebar-icon-inner"></div>
                </div>
            </div>
    
            <!-- Main Content -->
            <div class="main-content flex flex-column flex-fill">
                
                <!-- Topbar -->
                <div class="topbar">
                    <span class="topbar-title">Campaigns</span>
                    <button class="new-campaign-btn">
                        <span>+</span>
                        <span>New Campaign</span>
                    </button>
                </div>
    
                <!-- Stat Cards -->
                <div class="stat-cards-row">
                    <div class="stat-card">
                        <div class="stat-label">Active</div>
                        <div class="stat-value color-primary">24</div>
                        <div class="stat-delta">+3 this week</div>
                    </div>
                    <div class="stat-card">
                        <div class="stat-label">Total Scans</div>
                        <div class="stat-value color-secondary">48,291</div>
                        <div class="stat-delta">↑ 12% vs last month</div>
                    </div>
                    <div class="stat-card">
                        <div class="stat-label">Conversion</div>
                        <div class="stat-value color-tertiary">8.4%</div>
                        <div class="stat-delta">↑ 1.2pp</div>
                    </div>
                </div>
    
                <!-- Campaign List -->
                <div class="campaign-list-section">
                    <div class="campaign-list-title">Recent Campaigns</div>
                    <div class="campaign-list">
                        <div class="campaign-row">
                            <div class="campaign-status-dot active"></div>
                            <span class="campaign-name">Summer Sale 2025</span>
                            <span class="campaign-scans">12,441</span>
                            <span class="campaign-conversion">9.2%</span>
                        </div>
                        <div class="campaign-row">
                            <div class="campaign-status-dot active"></div>
                            <span class="campaign-name">Product Launch — AR Glasses</span>
                            <span class="campaign-scans">8,879</span>
                            <span class="campaign-conversion">11.4%</span>
                        </div>
                        <div class="campaign-row">
                            <div class="campaign-status-dot paused"></div>
                            <span class="campaign-name">Holiday Season Promo</span>
                            <span class="campaign-scans">3,834</span>
                            <span class="campaign-conversion">6.1%</span>
                        </div>
                        <div class="campaign-row">
                            <div class="campaign-status-dot active"></div>
                            <span class="campaign-name">In-Store QR Navigator</span>
                            <span class="campaign-scans">2,154</span>
                            <span class="campaign-conversion">14.3%</span>
                        </div>
                    </div>
                </div>
            </div>
    
            <!-- Right Panel -->
            <div class="right-panel flex">
                
                <!-- QR Preview Section -->
                <div class="panel-section flex flex-column">
                    <div class="panel-section-title">QR Preview</div>
                    <div class="qr-preview flex">
                        <span class="material-symbols-outlined mat-display-large">qr_code_2</span>
                    </div>
                </div>
    
                <!-- Sparkline Chart Section -->
                <div class="panel-section">
                    <div class="panel-section-title">Scans / 12h</div>
                    <div class="sparkline-container">
                        <div class="sparkline-bar" style="height: 28%;"></div>
                        <div class="sparkline-bar" style="height: 45%;"></div>
                        <div class="sparkline-bar" style="height: 35%;"></div>
                        <div class="sparkline-bar" style="height: 59%;"></div>
                        <div class="sparkline-bar" style="height: 48%;"></div>
                        <div class="sparkline-bar" style="height: 68%;"></div>
                        <div class="sparkline-bar" style="height: 62%;"></div>
                        <div class="sparkline-bar" style="height: 80%;"></div>
                        <div class="sparkline-bar" style="height: 72%;"></div>
                        <div class="sparkline-bar" style="height: 90%;"></div>
                        <div class="sparkline-bar" style="height: 84%;"></div>
                        <div class="sparkline-bar" style="height: 100%;"></div>
                    </div>
                </div>
    
                <!-- Top Channel Section -->
                <div class="panel-section">
                    <div class="panel-section-title">Top Channel</div>
                    <div class="top-channel-section">
                        <div class="channel-bar-item">
                            <div class="channel-bar-label">
                                <span class="channel-label">Print Ads</span>
                                <span class="channel-percentage">42%</span>
                            </div>
                            <div class="channel-bar-background">
                                <div class="channel-bar-fill" style="width: 42%;"></div>
                            </div>
                        </div>
                        <div class="channel-bar-item">
                            <div class="channel-bar-label">
                                <span class="channel-label">Packaging</span>
                                <span class="channel-percentage">31%</span>
                            </div>
                            <div class="channel-bar-background">
                                <div class="channel-bar-fill" style="width: 31%;"></div>
                            </div>
                        </div>
                        <div class="channel-bar-item">
                            <div class="channel-bar-label">
                                <span class="channel-label">Digital</span>
                                <span class="channel-percentage">27%</span>
                            </div>
                            <div class="channel-bar-background">
                                <div class="channel-bar-fill" style="width: 27%;"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--Floating badge-->
      <mat-card appearance="outlined" class="floating-badge p-box-8">
        <div class="flex flex-row gap-2 justify-center items-center">
          <div class="icon-container-filled primary flex justify-center items-center"><span class="material-symbols-outlined">arrow_outward</span></div>
            <div class="flex flex-column">
              <div class="mat-title-medium font-weight-bold on-surface ">34%</div>
              <div class="mat-label-small font-weight-bold on-surface">avg. conversion lift</div>
            </div>
        </div>
        
      </mat-card>
    </div>
    
    </div>
  </section>



  <!-- Features Section -->
  
  <section class="flex flex-column justify-center items-center">
    <div class="flex flex-row container-1024">
      <div class="flex flex-column gap-10 pt-100 pb-100">
        <div class="flex flex-row gap-4">
          <div class="custom-badge flex flex-row items-center gap-2">
            <span class="mat-body-small">Features</span>
          </div>
        </div>
        <div class="mat-display-medium flex flex-row font-weight-bold">
          Everything your <br> advertising team needs.
        </div> 
        <div class="flex flex-row mat-body-large font-weight-light">
          From campaign planning to post-campaign attribution — one platform, no duct tape.
      </div>
      <!--cards-->
        <div class="flex flex-row gap-6 lg:flex-column">
          <div class="flex flex-row gap-6 md:flex-column">
            <mat-card appearance="outlined" class="p-box-36 gap-6 basis-50 card-light">
              <div class="icon-container-filled primary flex justify-center items-center"><span class="material-symbols-outlined">stack</span></div>
              <div class="mat-title-medium font-weight-bold">Campaign Creation & Management</div>
              <div class="font-weight-light">Build multi-channel campaigns in minutes. Set budgets, audiences, and schedules from one unified interface. Version-control your assets and collaborate with your team in real time.</div>
              <div class="flex flex-row gap-2 flex-wrap">
                <mat-chip class="mat-body-small font-weight-light">Multi-channel</mat-chip>
                <mat-chip class="mat-body-small font-weight-light">Templates</mat-chip>
                <mat-chip class="mat-body-small font-weight-light">Team Collaboration</mat-chip>
              </div>
            </mat-card>
            <mat-card appearance="outlined" class="p-box-36 gap-6 basis-50 card-light">
              <div class="icon-container-filled secondary flex justify-center items-center"><span class="material-symbols-outlined">qr_code</span></div>
              <div class="mat-title-medium font-weight-bold">Smart QR Code Generation</div>
              <div class="font-weight-light">Generate dynamic, trackable QR codes that you can update after printing. Custom styling, logo embedding, and destination rules based on time, location, or device.</div>
              <div class="flex flex-row gap-2 flex-wrap">
                <mat-chip class="mat-body-small font-weight-light">Dynamic URLs</mat-chip>
                <mat-chip class="mat-body-small font-weight-light">Custom Design</mat-chip>
                <mat-chip class="mat-body-small font-weight-light">Geo-targeting</mat-chip>
              </div>
            </mat-card>
          </div>
          <div class="flex flex-row gap-6 md:flex-column">
            <mat-card appearance="outlined" class="p-box-36 gap-6 basis-50 card-light">
              <div class="icon-container-filled tertiary flex justify-center items-center"><span class="material-symbols-outlined">bar_chart</span></div>
              <div class="mat-title-medium font-weight-bold">Real-time Analytics & Tracking</div>
              <div class="font-weight-light">Watch scan events stream in live. Deep attribution reports, funnel analysis, A/B test results, and exportable dashboards your whole organization can act on.</div>
              <div class="flex flex-row gap-2 flex-wrap">
                <mat-chip class="mat-body-small font-weight-light">Live Events</mat-chip>
                <mat-chip class="mat-body-small font-weight-light">Funnel Analysis</mat-chip>
                <mat-chip class="mat-body-small font-weight-light">A/B Testing</mat-chip>
              </div>
            </mat-card>
            <mat-card appearance="outlined" class="p-box-36 gap-6 basis-50 card-light">
              <div class="icon-container-filled primary flex justify-center items-center"><span class="material-symbols-outlined">bolt</span></div>
              <div class="mat-title-medium font-weight-bold">Integrations & Open API</div>
              <div class="font-weight-light">Connect to your existing stack — Salesforce, HubSpot, Shopify, Google Analytics, and 50+ more. Or use our REST API and webhooks to build anything you need.</div>
              <div class="flex flex-row gap-2 flex-wrap">
                <mat-chip class="mat-body-small font-weight-light">REST API</mat-chip>
                <mat-chip class="mat-body-small font-weight-light">Webhooks</mat-chip>
                <mat-chip class="mat-body-small font-weight-light">50+ Integrations</mat-chip>
              </div>
            </mat-card>
          </div>
        </div>
      </div>
    </div>
  </section>


  <!--How it works-->
  <section class="flex flex-row container-fluid-flat surface-variant justify-center items-center">
    <div class="flex flex-column container-1024 gap-10 pt-100 pb-100">
      <div class="flex flex-row gap-4 justify-center">
        <div class="custom-badge flex flex-row gap-2 justify-center items-center">
          <span class="mat-body-small">How It Works</span>
        </div>
      </div>
      <div class="mat-display-medium font-weight-bold text-center">From sign-up to scan data in <br>four steps.</div> 
      <div class="flex flex-row gap-8 md:flex-column">
        <div class="flex flex-row sm:flex-column gap-8">
          <!--Step 1-->
        <div class="flex flex-column gap-4 items-center">
          <mat-card appearance="outlined" class="p-box-24">
            <div class="badge-primary flex justify-center items-center mat-label-small font-weight-bold">1</div>
            <span class="material-symbols-outlined primary-color">person_add</span>
          </mat-card>
          <div class="mat-title-medium font-weight-bold text-center">Create your account</div>
          <div class="font-weight-light text-center">Sign up in under 60 seconds. No credit card required. Set up your workspace and invite your team.</div>
        </div>
        <!--Step 2-->
        <div class="flex flex-column gap-4 items-center">
          <mat-card appearance="outlined" class="p-box-24">
            <div class="badge-primary flex justify-center items-center mat-label-small font-weight-bold">2</div>
            <mat-icon matBadge="15" class="material-symbols-outlined primary-color">stacks</mat-icon>
          </mat-card>
          <div class="mat-title-medium font-weight-bold text-center">Build your first campaign</div>
          <div class="font-weight-light text-center">Use our guided campaign builder to set your objective, audience, channels, and creative assets.</div>
        </div>
        </div>
        <div class="flex flex-row sm:flex-column gap-8">
          <!--Step 3-->
        <div class="flex flex-column gap-4 items-center">
          <mat-card appearance="outlined" class="p-box-24">
            <div class="badge-primary flex justify-center items-center mat-label-small font-weight-bold">3</div>
            <span class="material-symbols-outlined primary-color">qr_code</span>
          </mat-card>
          <div class="mat-title-medium font-weight-bold text-center">Generate trackable QR codes</div>
          <div class="font-weight-light text-center">Export campaign-linked QR codes for every placement. Update destination URLs anytime — even after printing.</div>
        </div>
        <!--Step 4-->
        <div class="flex flex-column gap-4 items-center">
          <mat-card appearance="outlined" class="p-box-24">
            <div class="badge-primary flex justify-center items-center mat-label-small font-weight-bold">4</div>
            <span class="material-symbols-outlined primary-color">monitoring</span>
          </mat-card>
          <div class="mat-title-medium font-weight-bold text-center">Monitor & optimize</div>
          <div class="font-weight-light text-center">Watch scans, conversions, and revenue roll in. Use built-in insights to double down on what's working.</div>
        </div>
        </div>
      </div>
    </div>
  </section>

  <!--Overview-->

  <section class="flex flex-row hero-container-fluid surface-tint items-center">
    <div class=" flex flex-row gap-6 items-center">
      <!--Left column-->
      <div class="flex flex-column gap-6">
        <div class="flex flex-row gap-4">
          <div class="custom-badge flex flex-row items-center gap-2">
            <span class="mat-body-small">Platform Overview</span>
          </div>
        </div>
        <div class="mat-display-large font-weight-bold">
          One dashboard.<br/>
          Total campaign
          <span class="accent-primary">clarity</span>.<br/>
        </div> 
        <div class="flex flex-row mat-body-large font-weight-light">
          See all your active campaigns, live scan counts, conversion funnels, and QR code performance side by side. No switching tabs. No wasted context.
        </div>
        <div class="flex flex-column gap-4">
          <div class="flex flex-row gap-4 items-center">
            <div class="icon-badge-inverse-primary flex justify-center items-center"><span class="material-symbols-outlined mat-title-large"  >check_small</span></div>
            <div class="mat-body-large font-weight-bold">Campaign list with real-time status indicators</div>
          </div>
          <div class="flex flex-row gap-4 items-center">
            <div class="icon-badge-inverse-primary flex justify-center items-center"><span class="material-symbols-outlined mat-title-large" >check_small</span></div>
            <div class="mat-body-large font-weight-bold">Integrated QR code generator and preview</div>
          </div>
          <div class="flex flex-row gap-4 items-center">
            <div class="icon-badge-inverse-primary flex justify-center items-center"><span class="material-symbols-outlined mat-title-large" >check_small</span></div>
            <div class="mat-body-large font-weight-bold">Live scan charts and conversion attribution</div>
          </div>
          <div class="flex flex-row gap-4 items-center">
            <div class="icon-badge-inverse-primary flex justify-center items-center"><span class="material-symbols-outlined mat-title-large" >check_small</span></div>
            <div class="mat-body-large font-weight-bold">Team workspace with role-based access</div>
          </div>
        </div>
      </div>
    <!--Right column-->
    <!-- Dashboard Mock -->
    <div class="dashboard-mockup flex flex-column hide-1024 basis-50">
                
      <!-- Browser Bar -->
      <div class="browser-bar">
          <div class="browser-buttons">
              <div class="browser-button"></div>
              <div class="browser-button"></div>
              <div class="browser-button"></div>
          </div>
          <div class="browser-url-bar">
              <div class="url-indicator-dot"></div>
              <span class="url-text">app.aauto.io/dashboard</span>
          </div>
          <div class="browser-controls">
              <div class="browser-control-btn"></div>
              <div class="browser-control-btn"></div>
              <div class="browser-control-btn"></div>
          </div>
      </div>
  
      <!-- App Shell -->
      <div class="app-shell flex flex-row">
          
          <!-- Sidebar -->
          <div class="sidebar flex flex-column p-box-8">
              <div class="sidebar-logo">
                  <div class="sidebar-logo-inner"></div>
              </div>
              <!-- Active icon -->
              <div class="sidebar-icon active">
                  <div class="sidebar-icon-inner"></div>
              </div>
              <!-- Inactive icons -->
              <div class="sidebar-icon">
                  <div class="sidebar-icon-inner"></div>
              </div>
              <div class="sidebar-icon">
                  <div class="sidebar-icon-inner"></div>
              </div>
              <div class="sidebar-icon">
                  <div class="sidebar-icon-inner"></div>
              </div>
              <div class="sidebar-icon">
                  <div class="sidebar-icon-inner"></div>
              </div>
          </div>
  
          <!-- Main Content -->
          <div class="main-content flex flex-column flex-fill">
              
              <!-- Topbar -->
              <div class="topbar">
                  <span class="topbar-title">Campaigns</span>
                  <button class="new-campaign-btn">
                      <span>+</span>
                      <span>New Campaign</span>
                  </button>
              </div>
  
              <!-- Stat Cards -->
              <div class="stat-cards-row">
                  <div class="stat-card">
                      <div class="stat-label">Active</div>
                      <div class="stat-value color-primary">24</div>
                      <div class="stat-delta">+3 this week</div>
                  </div>
                  <div class="stat-card">
                      <div class="stat-label">Total Scans</div>
                      <div class="stat-value color-secondary">48,291</div>
                      <div class="stat-delta">↑ 12% vs last month</div>
                  </div>
                  <div class="stat-card">
                      <div class="stat-label">Conversion</div>
                      <div class="stat-value color-tertiary">8.4%</div>
                      <div class="stat-delta">↑ 1.2pp</div>
                  </div>
              </div>
  
              <!-- Campaign List -->
              <div class="campaign-list-section">
                  <div class="campaign-list-title">Recent Campaigns</div>
                  <div class="campaign-list">
                      <div class="campaign-row">
                          <div class="campaign-status-dot active"></div>
                          <span class="campaign-name">Summer Sale 2025</span>
                          <span class="campaign-scans">12,441</span>
                          <span class="campaign-conversion">9.2%</span>
                      </div>
                      <div class="campaign-row">
                          <div class="campaign-status-dot active"></div>
                          <span class="campaign-name">Product Launch — AR Glasses</span>
                          <span class="campaign-scans">8,879</span>
                          <span class="campaign-conversion">11.4%</span>
                      </div>
                      <div class="campaign-row">
                          <div class="campaign-status-dot paused"></div>
                          <span class="campaign-name">Holiday Season Promo</span>
                          <span class="campaign-scans">3,834</span>
                          <span class="campaign-conversion">6.1%</span>
                      </div>
                      <div class="campaign-row">
                          <div class="campaign-status-dot active"></div>
                          <span class="campaign-name">In-Store QR Navigator</span>
                          <span class="campaign-scans">2,154</span>
                          <span class="campaign-conversion">14.3%</span>
                      </div>
                  </div>
              </div>
          </div>
  
          <!-- Right Panel -->
          <div class="right-panel flex">
              
              <!-- QR Preview Section -->
              <div class="panel-section flex flex-column">
                  <div class="panel-section-title">QR Preview</div>
                  <div class="qr-preview flex">
                      <span class="material-symbols-outlined mat-display-large">qr_code_2</span>
                  </div>
              </div>
  
              <!-- Sparkline Chart Section -->
              <div class="panel-section">
                  <div class="panel-section-title">Scans / 12h</div>
                  <div class="sparkline-container">
                      <div class="sparkline-bar" style="height: 28%;"></div>
                      <div class="sparkline-bar" style="height: 45%;"></div>
                      <div class="sparkline-bar" style="height: 35%;"></div>
                      <div class="sparkline-bar" style="height: 59%;"></div>
                      <div class="sparkline-bar" style="height: 48%;"></div>
                      <div class="sparkline-bar" style="height: 68%;"></div>
                      <div class="sparkline-bar" style="height: 62%;"></div>
                      <div class="sparkline-bar" style="height: 80%;"></div>
                      <div class="sparkline-bar" style="height: 72%;"></div>
                      <div class="sparkline-bar" style="height: 90%;"></div>
                      <div class="sparkline-bar" style="height: 84%;"></div>
                      <div class="sparkline-bar" style="height: 100%;"></div>
                  </div>
              </div>
  
              <!-- Top Channel Section -->
              <div class="panel-section">
                  <div class="panel-section-title">Top Channel</div>
                  <div class="top-channel-section">
                      <div class="channel-bar-item">
                          <div class="channel-bar-label">
                              <span class="channel-label">Print Ads</span>
                              <span class="channel-percentage">42%</span>
                          </div>
                          <div class="channel-bar-background">
                              <div class="channel-bar-fill" style="width: 42%;"></div>
                          </div>
                      </div>
                      <div class="channel-bar-item">
                          <div class="channel-bar-label">
                              <span class="channel-label">Packaging</span>
                              <span class="channel-percentage">31%</span>
                          </div>
                          <div class="channel-bar-background">
                              <div class="channel-bar-fill" style="width: 31%;"></div>
                          </div>
                      </div>
                      <div class="channel-bar-item">
                          <div class="channel-bar-label">
                              <span class="channel-label">Digital</span>
                              <span class="channel-percentage">27%</span>
                          </div>
                          <div class="channel-bar-background">
                              <div class="channel-bar-fill" style="width: 27%;"></div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <!--Floating badge-->
    <mat-card appearance="outlined" class="floating-badge p-box-8">
      <div class="flex flex-row gap-2 justify-center items-center">
        <div class="icon-container-filled primary flex justify-center items-center"><span class="material-symbols-outlined">arrow_outward</span></div>
          <div class="flex flex-column">
            <div class="mat-title-medium font-weight-bold on-surface ">34%</div>
            <div class="mat-label-small font-weight-bold on-surface">avg. conversion lift</div>
          </div>
      </div>
      
    </mat-card>
  </div>
    </div>
  </section>

  <!--Customer Stories-->
  <section class="flex flex-column justify-center items-center">
    <div class="flex flex-row container-1024">
      <div class="flex flex-column gap-10 pt-100 pb-100">
        <div class="flex flex-row gap-4">
          <div class="custom-badge flex flex-row items-center gap-2">
            <span class="mat-body-small">Customer Stories</span>
          </div>
        </div>
        <div class="mat-display-medium flex flex-row font-weight-bold">
          Built for teams who take <br> advertising seriously.
        </div> 
      <!--cards-->
        <div class="flex flex-row gap-6 md:flex-column">
          <mat-card appearance="outlined" class="p-box-36 gap-6 card-light">
            <div class="flex flex-column gap-4">
              <div class="flex flex-column gap-1">
                <div class="flex flex-row gap-1">
                  <span class="mat-body-large primary-color">★</span>
                  <span class="mat-body-large primary-color">★</span>
                  <span class="mat-body-large primary-color">★</span>
                  <span class="mat-body-large primary-color">★</span>
                  <span class="mat-body-large primary-color">★</span>
                </div>
                <div class="flex mat-display-large font-weight-bold">"</div>
              </div>
              <div class="font-weight-light">Aauto cut our campaign setup time by 70%. The QR code analytics alone have changed how we think about out-of-home advertising — we finally have real attribution data.</div>
              <mat-divider></mat-divider>
              <div class="flex flex-row gap-2 items-center">
                <div class="avatar flex flex-column items-center justify-center primary-container mat-body-large font-weight-regular">SA</div>
                <div class="flex flex-column">
                  <div class="flex mat-body-large font-weight-bold">Sarah Alderman</div>
                  <div class="flex mat-body-small font-weight-light">Head of Marketing</div>
                </div>
            </div>
            </div>
          </mat-card>
          <mat-card appearance="outlined" class="p-box-36 gap-6 card-light">
            <div class="flex flex-column gap-4">
              <div class="flex flex-column gap-1">
                <div class="flex flex-row gap-1">
                  <span class="mat-body-large primary-color">★</span>
                  <span class="mat-body-large primary-color">★</span>
                  <span class="mat-body-large primary-color">★</span>
                  <span class="mat-body-large primary-color">★</span>
                  <span class="mat-body-large primary-color">★</span>
                </div>
                <div class="flex mat-display-large font-weight-bold">"</div>
              </div>
              <div class="font-weight-light">We manage 80+ active campaigns simultaneously. Before aauto, that meant spreadsheets and Slack threads. Now everything is in one place and our team actually uses it.</div>
              <mat-divider></mat-divider>
              <div class="flex flex-row gap-2 items-center">
                <div class="avatar flex flex-column items-center justify-center secondary-container mat-body-large font-weight-regular">MK</div>
                <div class="flex flex-column">
                  <div class="flex mat-body-large font-weight-bold">Marcus Kim</div>
                  <div class="flex mat-body-small font-weight-light">VP Growth</div>
                </div>
            </div>
            </div>
          </mat-card>
          <mat-card appearance="outlined" class="p-box-36 gap-6 card-light">
            <div class="flex flex-column gap-4">
              <div class="flex flex-column gap-1">
                <div class="flex flex-row gap-1">
                  <span class="mat-body-large primary-color">★</span>
                  <span class="mat-body-large primary-color">★</span>
                  <span class="mat-body-large primary-color">★</span>
                  <span class="mat-body-large primary-color">★</span>
                  <span class="mat-body-large primary-color">★</span>
                </div>
                <div class="flex mat-display-large font-weight-bold">"</div>
              </div>
              <div class="font-weight-light">The dynamic QR codes are a game-changer. We update destination URLs for seasonal promos without reprinting anything. The ROI on our print budget has never been clearer.</div>
              <mat-divider></mat-divider>
              <div class="flex flex-row gap-2 items-center">
                <div class="avatar flex flex-column items-center justify-center tertiary-container mat-body-large font-weight-regular">RJ</div>
                <div class="flex flex-column">
                  <div class="flex mat-body-large font-weight-bold">Renata Jensen</div>
                  <div class="flex mat-body-small font-weight-light">Digital Director</div>
                </div>
            </div>
            </div>
          </mat-card>
        </div>
      </div>
    </div>
  </section>

  <!--contact us-->
  <section class="flex flex-row container-fluid surface-tint items-center justify-center">
    <div class="flex flex-column gap-10 pt-100 pb-100 items-center">
      <div class="mat-display-medium flex flex-row font-weight-bold text-center">
        Ready to transform your<br> advertising campaigns?
      </div>
      <div class="mat-body-large flex flex-row font-weight-bold text-center">
        Join 100+ marketing teams already using Aauto to run smarter campaigns and prove ROI at every touchpoint.
      </div> 
      <div class="flex flex-row gap-4 sm:flex-column">
        <input type="email" class="cta-input" placeholder="name@company.com">
        <button class="flat" matFab extended>
          <mat-icon>arrow_right_alt</mat-icon>
          Get started.
        </button>
      </div>
    </div>
  </section>

     <!--Footer-->
     <footer class="flex flex-column container-fluid-flat inverse-surface">
      <div class="flex flex-column gap-10 container-1024">
        <div class=" flex flex-column gap-4 pt-100">
          <div class="flex flex-row items-center gap-2">
            <svg class="aauto-logo" width="100%" height="100%" viewBox="0 0 56 64" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M25.0605 0.790596C26.8793 -0.264184 29.1207 -0.264183 30.9395 0.790596L53.0605 13.6207C54.8792 14.6754 55.9998 16.6245 56 18.734V44.3931C56 46.5028 54.8793 48.4526 53.0605 49.5074L30.9395 62.3365C29.1206 63.3913 26.8794 63.3913 25.0605 62.3365L2.93945 49.5074C1.12065 48.4526 0 46.5028 0 44.3931V18.734C0.00015479 16.6245 1.12077 14.6754 2.93945 13.6207L25.0605 0.790596ZM30.9443 3.84431C29.1221 2.79135 26.8769 2.79124 25.0547 3.84431L5.49023 15.1509L5.32129 15.2525C3.59896 16.326 2.54607 18.2162 2.5459 20.2564V42.8707L2.54883 43.0679C2.6165 45.0978 3.72508 46.956 5.49023 47.9761L25.0547 59.2828C26.8769 60.3359 29.1221 60.3358 30.9443 59.2828L50.5098 47.9761C52.2748 46.9559 53.3835 45.0977 53.4512 43.0679L53.4541 42.8707V20.2564C53.4539 18.1504 52.3318 16.204 50.5098 15.1509L30.9443 3.84431ZM25.791 5.12067C27.1576 4.33091 28.8414 4.33106 30.208 5.12067L49.7734 16.4273C51.1399 17.2171 51.9823 18.677 51.9824 20.2564V42.8707C51.9824 44.4502 51.14 45.9099 49.7734 46.6998L30.208 58.0064C28.8413 58.7961 27.1576 58.7962 25.791 58.0064L6.22656 46.6998C4.8599 45.9099 4.01761 44.4503 4.01758 42.8707V20.2564C4.01775 18.6769 4.86002 17.2171 6.22656 16.4273L25.791 5.12067ZM31.4746 13.7457C30.9746 13.7457 30.5287 14.0644 30.3633 14.5406L28.2764 20.5465L26.2266 14.5982C26.0619 14.1208 25.6152 13.8013 25.1143 13.8013H21.6562C21.1563 13.8014 20.7113 14.1201 20.5459 14.5963L10.249 44.2379C9.98106 45.0102 10.5494 45.8179 11.3604 45.8179H14.2529C14.7533 45.8179 15.1991 45.4987 15.3643 45.022L18.0723 37.2056H21.1719C21.2334 37.2056 21.2832 37.1554 21.2832 37.0933C21.2831 35.6403 20.4636 34.3813 19.2656 33.7593L22.291 25.0289C22.6594 23.9661 24.1498 23.9687 24.5146 25.0328L25.6094 28.2261L20.0674 44.1822C19.7993 44.9545 20.3668 45.7622 21.1777 45.7623H24.0713C24.5715 45.7621 25.0166 45.4429 25.1816 44.9664L28.2812 36.0191L31.3672 45.0191C31.5313 45.4975 31.9788 45.8179 32.4805 45.8179H35.3311C36.141 45.8179 36.7094 45.0118 36.4434 44.2398L33.792 36.5504C34.768 35.875 35.4092 34.7421 35.4092 33.4576C35.409 33.3957 35.3592 33.3454 35.2979 33.3453H32.6875L30.9521 28.3101L32.1094 24.9732C32.4778 23.9106 33.9682 23.9131 34.333 24.9771L41.1855 44.9634C41.3497 45.4418 41.7962 45.7623 42.2979 45.7623H45.1494C45.9592 45.7621 46.5268 44.956 46.2607 44.1842L36.0439 14.5425C35.8792 14.0653 35.4335 13.7457 34.9326 13.7457H31.4746Z" fill="var(--mat-sys-tertiary)"/>
            </svg>
            <div class="mat-title-medium font-weight-bold">Aauto<span class="primary-color">.</span></div>
          </div>
          <div class="flex flex-row mat-body-small font-weight-light">
            The advertising management platform for modern marketing teams. Create, track, and optimize campaigns across every channel.
          </div>
        </div>
        <mat-divider></mat-divider>
    
        <div class="flex flex-row mat-body-small font-weight-light pb-24">
          © 2026 Aauto, All rights reserved.
        </div>
      </div>

    </footer>
</div>
}